import { normalizeLocale } from '@/i18n/config';
import { localizeMarketingLandingCopy } from '@/i18n/marketing-landing-copy';

/** Flat navigation for legal pages; shared marketing headers own the Solutions menu. */
export function getMarketingNavigationLinks(requestedLocale: string) {
  const locale = normalizeLocale(requestedLocale);
  const copy = localizeMarketingLandingCopy(locale);
  const localize = (link: { label: string; href: string }) => ({
    ...link,
    href: locale === 'en' ? link.href : `/${locale}${link.href}`,
  });
  return {
    navLinks: copy.primaryNav
      .filter(({ href }) => href.startsWith('/'))
      .map(localize),
    footerLinks: copy.footerGroups.flatMap(({ links }) => links).map(localize),
  };
}
